<p-fileUpload
  name="photoFile"
  url="/api/photos"
  (onBeforeUpload)="onBeforeUpload($event)"
  (onUpload)="onUpload($event)"
  (onError)="onError($event)"
  accept=".jpg,.jpeg,.png,.JPG,.JPEG,.PNG"
  invalidFileTypeMessageDetail="Only PNG and JPEG images are supported."
  invalidFileTypeMessageSummary="Invalid file type,"
  [disabled]="disableUpload"
  [showCancelButton]="!disableUpload"
  [multiple]="true"
  [mode]="basic ? 'basic' : 'advanced'"
  [auto]="basic"
  [chooseLabel]="chooseLabel"
  [ngClass]="basic ? 'basic' : ''"
  (onSelect)="onFileSelect($event)"
  (onRemove)="onRemove($event)">
  <ng-template #empty>
    @if (isShowDragContent) {
      <p class="content-message">Drop  Your File Here</p>
    }
  </ng-template>
</p-fileUpload>
